import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Sidebar } from "arui-feather/sidebar";
import _ from "lodash";
import moment from "moment-timezone";
import styled from "styled-components";

import EventsApi from "../../api/events-api";
import LabsApi from "../../api/labs-api";
import UniversityApi from "../../api/university-api";
import { useStorageListener } from "../../hooks/useStorage";
import { DormitorySearchPreview } from "../pages/search-results-page";
import { Button } from "../ui-kit/styled-templates";
import DormsMap from "./DormsMap";
import InteractiveMapEnhanced from "./interactive-map-enhanced";

function getDistrinctStatsInfo(distrinct, allUnis, allDorms, allEvents, allLabs) {
    console.log("getDistrinctStatsInfo: distrinct = ", distrinct);
    console.log("getDistrinctStatsInfo: allUnis = ", allUnis);
    console.log("getDistrinctStatsInfo: allDorms = ", allDorms);
    console.log("getDistrinctStatsInfo: allEvents = ", allEvents);
    console.log("getDistrinctStatsInfo: allLabs = ", allLabs);

    let unis = allUnis.filter((x) => x?.details?.district == distrinct);
    let unisIds = unis.map((x) => x.id);
    let dorms = allDorms.filter((x) => unisIds.indexOf(x.universityId) > -1);
    let events = allEvents.filter((x) => unisIds.indexOf(x.universityId) > -1);
    let labs = allLabs.filter((x) => unisIds.indexOf(x.universityId) > -1);
    let roomsAmount = 0;
    for (let i in dorms) {
        let xRooms = dorms[i]?.rooms || {};
        for (let key in xRooms) {
            let xr = xRooms[key]?.details?.amount || 0;
            roomsAmount = +roomsAmount + +xr;
        }
    }
    return {
        eventsNumber: events.length,
        labsNumber: labs.length,
        roomsNumber: roomsAmount,
        universitiesNumber: unis.length,
        dormsNumber: dorms.length,
    };
}

const DISTRICTS_MAP = (t) => ({
    ЦФО: {
        key: t("f55in8b4zg4"),
        name: t("l0sgpdspiwf"),
        description: ` Центральный федеральный округ включает в себя 18 субъектов Российской Федерации — Белгородскую область, Брянскую область, Владимирскую область, Воронежскую область, Ивановскую область, Калужскую область, Костромскую область, Курскую область, Липецкую область, Москву, Московскую область, Орловскую область, Рязанскую область, Смоленскую область, Тамбовскую область, Тверскую область, Тульскую область, Ярославскую область. Центр округа — город Москва.
Площадь — 652,7 тыс. кв. км (3,8% от территории России). Население — 37,3 млн человек (25,5% жителей страны).
Местоположение ЦФО — центр Европейской части России.
На территории округа берут начало такие крупные реки Европы как Волга, Дон, Днепр.
Главное природное богатство округа — железные руды Курской магнитной аномалии (КМА) — самого мощного в мире железорудного бассейна. Её залежи оцениваются в 200-210 млрд. тонн, что составляет около половины железорудных запасов на планете. Она расположена в пределах Курской, Белгородской и Орловской областей.
Лидирующими отраслями в промышленном комплексе ЦФО являются машиностроение и металлообработка. Здесь развиты ракетно-космическая промышленность, авиастроение, электронная и радиопромышленность, железнодорожное машиностроение. Важной отраслью является химическая промышленность. Регион производит до 30% продукции лёгкой промышленности в стране.
`,
    },

    СКФО: {
        key: t("sgysv3ug0tp"),
        name: t("y6dy85vfnkp"),
        description: `Северо-Кавказский федеральный округ включает в себя 6 республик (Дагестан, Ингушетия, Кабардино-Балкария, Карачаево-Черкесия, Северная Осетия — Алания, Чеченская республика) и Ставропольский край. Центр округа — город Пятигорск.
Округ расположен на юге европейской части России, в центральной и восточной части Северного Кавказа. Площадь территории округа составляет около одного процента от площади территории России. На востоке федеральный округ ограничен Каспийским морем, на юге — Главным Кавказским хребтом и границами с Грузией и Азербайджаном,
Численность населения округа составляет 9,6 миллиона человек (6.6 % населения России).
Северо-Кавказский федеральный округ имеет благоприятные условия для развития агропромышленного комплекса, туризма, санаторно-курортной сферы, электроэнергетики, добывающих и обрабатывающих секторов промышленности, а также развитые транзитные функции.
`,
    },

    ЮФО: {
        key: t("gmwcae21bfq"),
        name: t("12j685f1p46"),
        description: `Южный федеральный округ образован в 2000 г. Центр федерального округа - г.Ростов-на-Дону. (с 28 июля 2016 года в состав округа вошли Республика Крым и город Севастополь, Указ Президента Российской Федерации от 28 июля 2016 года №375 «О Южном федеральном округе»)
Площадь территории на 1 января 2019 г. составляет 447,8 тыс. кв. км (2,61% от территории РФ).
В округ входят 8 субъектов Российской Федерации: Республики Адыгея, Калмыкия; Крым, Краснодарский край; Астраханская, Волгоградская, Ростовская области, г. Севастополь.
Население федерального округа на 1 января 2019 г. составляет 16454,6 тыс. чел. (11,21% от численности населения РФ).
Доля городского населения на 1 января 2019 г. - 62,7%.
Плотность населения на 1 января 2019 г. - 36,7 чел./кв. км.
Округ расположен на юге Европейской части Российской Федерации, включает (с 28 июля 2016 г.) Крымский полуостров, соединенный с материком Перекопским перешейком (7-23 км). Омывается Азовским, Черным и Каспийским морями. Сосредоточены основные морские курорты: Сочи, Анапа, Геленджик,  Крым.
Протяженность с запада на восток - 360 км, с севера на юг - 180 км.
В недрах округа много разнообразных полезных ископаемых. Топливно-энергетические ресурсы представлены нефтью и природным газом, а также каменным углем
Нерудные полезные ископаемые представлены горно-химическим сырьем (значительны запасы барита, каменной соли, серы). 
`,
    },

    СФО: {
        key: t("1wuqcbt499wj"),
        name: t("m2stp83mvno"),
        description: `Сибирский федеральный округ включает в себя 12 субъектов Российской Федерации — Республику Алтай, Алтайский край, Республику Бурятия, Забайкальский край, Иркутскую область, Кемеровскую область, Красноярский край, Новосибирскую область, Омскую область, Томскую область, Республику Тыва, Республику Хакасия. Центр округа — город Новосибирск.
Площадь округа — 5114,8 тыс. кв. км (30% от площади страны).  Население — 20 млн. человек (14% населения России).
По территории округа протекает самая многоводная в России река — Енисей. Берега округа омывают Карское море и Море Лаптевых Северного Ледовитого океана. На юге Восточной Сибири расположено озеро Байкал, которое находится на первом месте в мире по глубине (1620 м) и объему пресной воды (1/5 мировых запасов).
На территории СФО сосредоточены: 85% российских запасов свинца и платины, 80% угля и молибдена, 71% никеля, 69% меди, 44% серебра, 40% золота.
Ведущие отрасли промышленности — черная и цветная металлургия, лесная, деревообрабатывающая, химическая, нефтехимическая, пищевая, легкая промышленность, производство строительных материалов, машиностроение и металлообработка. В округе работают крупные промышленные предприятия атомной и космической промышленности. Здесь находятся самые крупные в России гидроэлектростанции: Красноярская, Саяно-Шушенская, Братская, Усть-Илимская и Обская ГЭС.
Большую экономическую ценность имеют лесные ресурсы Сибири.
Важнейшими отраслями сельского хозяйства округа являются животноводство, производство зерна, овощеводство. 
`,
    },

    ДФО: {
        key: t("am9uy99qbo4"),
        name: t("rf9hbrobxh"),
        description: `Дальневосточный федеральный округ включает в себя 9 субъектов Российской Федерации — Амурскую область, Еврейскую автономную область, Камчатский край, Магаданскую область, Приморский край, Республику Саха (Якутия), Сахалинскую область, Хабаровский край, Чукотский автономный округ. Центр округа — город Хабаровск.
ДФО — самый большой по территории округ в России. Его площадь составляет 6215,9 тыс. кв. км (36,4% территории России). В округе живут более 7 миллионов человек (4,9% населения России).
Омываемый двумя океанами — Северным Ледовитым и Тихим, ДФО имеет самую большую в России протяженность морского побережья — более 9000 км. В округе расположены самый крупный в России полуостров — Камчатка (350 тыс. кв. км), самый крупный остров — Сахалин (76,4 тыс. кв. км), архипелаг с наибольшим числом островов — Курилы, один из крупнейших действующих вулканов мира — Ключевская сопка (4750 м). В число наиболее крупных рек мира входят Лена и Амур.
Дальний Восток обладает богатейшими запасами природных ресурсов,  в их числе золото, алмазы, нефть, газ. В экономике округа представлены горнодобывающая, лесная, деревообрабатывающая, рыбная промышленность, цветная металлургия, морской и железнодорожный транспорт, машиностроение, гидроэнергетика и традиционные для Дальнего Востока оленеводство, охота, пушное звероводство.
`,
    },

    ПФО: {
        key: t("9ia3h9rfazr"),
        name: t("i9y14zg4gw"),
        description: `Приволжский федеральный округ включает в себя 6 республик (Башкортостан, Марий-Эл, Мордовия, Татарстан, Удмуртия, Чувашия), 7 областей (Кировская, Нижегородская, Оренбургская, Пензенская, Самарская, Саратовская, Ульяновская) и Пермский край. Центр округа — город Нижний Новгород.
Площадь округа составляет 1 038,0 тыс. кв. км (6,1% от территории России). Численность населения — 30,9 млн. чел. (22,1% населения страны).         
Местоположение ПФО — центр и восток европейской части России.
Основной водной артерией региона является река Волга. Большая часть территории округа расположена в ее бассейне.
Запасы нефти округа составляют 13 % от общероссийских, газа — 2 %. На территории округа сосредоточены запасы калийных солей (90 % общероссийских), фосфоритов (60 %), цинка (20 %), меди (16 %), серебра (16 %), золота (17 %).
Доля промышленного производства ПФО в экономике России составляет 23,9% — это высший показатель (на втором месте стоит Центральный федеральный округ). В структуре промышленности первенствуют машиностроение и топливно-энергетический комплекс. Существенную долю промышленного производства ПФО составляют продукция сельского хозяйства, химической и легкой промышленности.
`,
    },

    СЗФО: {
        key: t("tnyw3doyotb"),
        name: t("knl2vdks7o"),
        description: `Северо-Западный федеральный округ включает в себя 11 субъектов Российской Федерации — Архангельскую область, Вологодскую область, Калининградскую область, Республику Карелия, Республику Коми, Ленинградскую область, Мурманскую область, Ненецкий автономный округ, Новгородскую область, Псковскую область, город Санкт-Петербург. Центр округа — город Санкт-Петербург.
СЗФО расположен на севере Восточно-Европейской (Русской) равнины. Площадь — 1 687 тыс. кв. км (9,9% от территории России). Население  — более 13,5 миллиона человек (9,5% жителей страны).
Берега округа омываются 5 морями, принадлежащими бассейнам двух океанов: Атлантического (Балтийское море) и Северного Ледовитого (Баренцево, Печерское, Белое, Карское), соединенных Беломоро-Балтийским каналом.
Большую часть территория СЗФО занимают леса. На сельскохозяйственные угодья приходится около 3% площади.
Ресурсно-сырьевая база СЗФО не относится к числу наиболее богатых в России. Тем не менее, в округе сосредоточена добыча апатитов (72% общероссийских запасов) и титана (77%). Запасы нефти и газа составляют около 8% от общероссийских, угля — около 3%. В округе большие запасы торфа и горючих сланцев.
В СЗФО добывается около 19% никеля и железных руд в России. Здесь расположены крупные запасы алмазов (19% от общероссийских), имеются месторождения редких металлов, золота, урана.
Здесь развито машиностроение (турбины, станки, дизели), химическая, легкая промышленность, лесная, деревообрабатывающая и целлюлозно-бумажная промышленность, металлургия. Развито наукоемкое производство (электроника и электротехника, приборостроение, судостроение).    
По улову рыбы СЗФО занимает второе место после Дальневосточного федерального округа.
`,
    },

    УФО: {
        key: t("q0s0wrsgt1"),
        name: t("7c2em9yvqgk"),
        description: `Уральский федеральный округ включает в себя 6 субъектов Российской Федерации — Курганскую, Свердловскую, Тюменскую и Челябинскую области, Ханты-Мансийский и Ямало-Ненецкий автономные округа. Центр округа — город Екатеринбург.
Площадь УрФО — 1788,9 тыс. кв. км (10,5% от территории  России). Численность населения — 12,6 млн. чел. (8,6% жителей страны).
В значительной своей части округ расположен в пределах Западно-Сибирской равнины, на западе округа находятся восточные склоны Уральских гор. Основная водная артерия — река Обь с крупнейшим притоком Иртышом. Территория округа имеет выход к Северному Ледовитому океану.
УрФО обладает крупными месторождениями минерального сырья. В Ханты-Мансийском и Ямало-Ненецком автономных округах разведаны и эксплуатируются нефтяные и газовые месторождения, относящиеся к Западно-Сибирской нефтегазоносной провинции, в которой сосредоточено 66,7 % запасов нефти РФ (6 % мировых) и 77,8 % газа РФ (26 % мировых запасов). Потенциальные возможности заготовки древесины свыше 50 млн. куб. метров.
Округ богат запасами и других видов минерально-сырьевых ресурсов: железными и медными рудами, бокситами, асбестом, тальком, мрамором, золотом, платиной, драгоценными и поделочными камнями.
В экономике округа ведущую роль играют топливно-энергетический комплекс, металлургия вместе с сырьевой базой, машиностроение и высокие технологии, атомная промышленность, оборонный комплекс, сельское хозяйство, транспорт (железнодорожный и трубопроводный).
`,
    },
});

export default function InteractiveLandingMap(props) {
    const { t } = useTranslation();

    const [overlayVisible, setOverlayVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState(undefined);

    const ref = useRef();

    const universities = useStorageListener(`universities`, {});
    // const universities = useStorageListener(`universities`, {});
    // const events = useStorageListener((state) => _.values(state?.events));
    const university = useStorageListener(`universities`, {});
    const dormitories = useStorageListener((state) => _.values(state?.dormitories));
    const rooms = useStorageListener((state) => _.values(state?.rooms));
    const allLabs = useStorageListener((state) => _.values(state?.labs));
    // const allUnis = useStorageListener((state) => _.values(state?.universities));
    const allUnis = _.values(university);
    const [selectedDistrict, setSelectedDistrict] = useState(undefined);

    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    useEffect(EventsApi.getEvents, []);
    useEffect(LabsApi.getLabs, []);

    useOnClickOutside(ref, () => {
        setSelectedDistrict(undefined);
    });

    const allEvents = useStorageListener((state) => _.values(state?.events));

    const events = useStorageListener((state) => _.values(state?.events)?.filter?.((i) => i?.universityId === selectedItem?.universityId) ?? []);
    const labs = useStorageListener((state) => _.values(state?.labs)?.filter?.((i) => i?.universityId === selectedItem?.universityId) ?? []);

    // console.log("rooms: = ", rooms);
    // console.log("allLabs: = ", allLabs);
    // console.log("labs: = ", labs);
    // console.log("allEvents: = ", allEvents);
    // console.log("events: = ", events);
    console.log("allUnis: = ", allUnis);
    console.log("render: selectedDistrict = ", selectedDistrict);
    let distrInfo =
        selectedDistrict == undefined ? undefined : getDistrinctStatsInfo(selectedDistrict?.key, allUnis, dormitories, allEvents, allLabs);

    console.log("render: distrInfo = ", distrInfo);

    return (
        <Wrapper>
            {/*<Img src={map_pp} style={{ objectFit: "contain" }} onClick={() => {*/}
            {/*    setOverlayVisible(true);*/}
            {/*}} />*/}

            <InteractiveMapEnhanced
                onItemClick={(dd) => {
                    console.log("onItemClick: dd = ", dd);
                    let dId = dd?.id;
                    console.log("dId = ", dId);
                    console.log("DISTRICTS_MAP = ", DISTRICTS_MAP(t));
                    let xRes = DISTRICTS_MAP(t)[dId];
                    console.log("--> xRes = ", xRes);
                    if (dId == undefined) {
                        setOverlayVisible(true);
                    } else {
                        setSelectedDistrict(DISTRICTS_MAP(t)[dd?.id]);
                    }
                }}
            />

            {overlayVisible == false ? null : (
                <OverplayPlaceholder>
                    <InnerOverlay>
                        <DormsMap
                            onSelect={(x) => {
                                // console.log("xx = ", x);
                                setSelectedItem(x);
                            }}
                        />
                    </InnerOverlay>

                    <CloseFixed
                        onClick={() => {
                            setOverlayVisible(false);
                        }}
                    >
                        {t("3wqe14pk0qi")}
                    </CloseFixed>
                </OverplayPlaceholder>
            )}

            <Sidebar
                width={Math.min(window.innerWidth, 820)}
                visible={selectedItem != undefined}
                onCloserClick={() => {
                    setSelectedItem(undefined);
                }}
            >
                {selectedItem == undefined ? null : (
                    <SidebarInner>
                        {/*{JSON.stringify(selectedItem)}*/}
                        {/*<DormitoryPublicPage dormitoryId={selectedItem?.id} />*/}
                        {/*<DormitorySearchPrevie*/}

                        <div>
                            <h2>{(_.get(universities, `${selectedItem?.universityId}.details`) || {})["name"]}</h2>
                        </div>

                        <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                try {
                                    window.open(`/dormitory/${selectedItem.id}`, "_blank").focus();
                                } catch (exc) {}
                            }}
                        >
                            <DormitorySearchPreview.Component
                                {...selectedItem.details}
                                rooms={_.values(rooms)?.filter?.((i) => i?.dormitoryId === selectedItem?.id)}
                                university={_.get(universities, `${selectedItem?.universityId}.details`)}
                            />
                        </div>

                        {events == undefined || events.length == 0 ? null : (
                            <div>
                                <h3>{`Мероприятия ${events.length < 2 ? "" : `(${events.length})`}`}</h3>
                                {events.map((a, i) => {
                                    let item = a?.details;
                                    return (
                                        <EventItem key={a.id}>
                                            <Link to={`/events/${a?.id}`} target="_blank">
                                                <div style={{ fontSize: 16, fontWeight: "bold" }}>{a?.details?.name}</div>
                                            </Link>
                                            <div
                                                style={{
                                                    fontWeight: "bold",
                                                    marginLeft: 10,
                                                    opacity: 0.6,
                                                    fontStyle: "italic",
                                                    fontSize: 12,
                                                    textAlign: "right",
                                                }}
                                            >
                                                {moment(item?.dates?.from).format(`DD.MM.YYYY`)}
                                                <br />
                                                {moment(item?.dates?.to).format(`DD.MM.YYYY`)}
                                            </div>
                                        </EventItem>
                                    );
                                })}
                            </div>
                        )}

                        {labs == undefined || labs.length == 0 ? null : (
                            <div>
                                <h3>{`Объекты научной инфраструктуры ${labs.length < 2 ? "" : `(${labs.length})`}`}</h3>
                                {labs.map((a, i) => {
                                    let item = a?.details;
                                    return (
                                        <EventItem key={a.id}>
                                            <Link to={`/lab/${a?.id}`} target="_blank">
                                                <div style={{ fontSize: 16, fontWeight: "bold" }}>{a?.details?.name}</div>
                                            </Link>

                                            {/*<div style={{fontWeight: 'bold', marginLeft: 10, opacity: 0.6, fontStyle: 'italic', fontSize: 12, textAlign: 'right'}} >*/}
                                            {/*    {moment(item?.dates?.from).format(`DD.MM.YYYY`)}*/}
                                            {/*    <br/>*/}
                                            {/*    {moment(item?.dates?.to).format(`DD.MM.YYYY`)}*/}
                                            {/*</div>*/}
                                        </EventItem>
                                    );
                                })}
                            </div>
                        )}

                        {/*<div>*/}
                        {/*    <h2>*/}
                        {/*        События*/}
                        {/*    </h2>*/}
                        {/*    {events.length}*/}
                        {/*</div>*/}
                    </SidebarInner>
                )}
            </Sidebar>

            {selectedDistrict == undefined ? null : (
                <DistrictModalOverlay>
                    <DistrictModalOverlayInner>
                        <DistrictModalBox ref={ref}>
                            <h2>{selectedDistrict?.name}</h2>
                            {distrInfo == undefined ? null : (
                                <div
                                    style={{
                                        paddingBottom: 10,
                                        marginBottom: 10,
                                        borderBottom: "1px solid whitesmoke",
                                    }}
                                >
                                    <div>
                                        <XLabel>{`Университеты: `}</XLabel>
                                        <span>{`${distrInfo?.universitiesNumber}`}</span>
                                    </div>
                                    <div>
                                        <XLabel>{`Общежития: `}</XLabel>
                                        <span>{`${distrInfo?.dormsNumber}`}</span>
                                    </div>
                                    <div>
                                        <XLabel>{`Места размещения: `}</XLabel>
                                        <span>{`${distrInfo?.roomsNumber}`}</span>
                                    </div>
                                    <div>
                                        <XLabel>{`События: `}</XLabel>
                                        <span>{`${distrInfo?.eventsNumber}`}</span>
                                    </div>
                                    <div>
                                        <XLabel>{`Объекты научной инфраструктуры: `}</XLabel>
                                        <span>{`${distrInfo?.labsNumber}`}</span>
                                    </div>
                                </div>
                            )}

                            <DescrPlaceholder>
                                <div dangerouslySetInnerHTML={{ __html: `${selectedDistrict?.description}`.replace(/\n/g, "<br/><br/>") }}></div>
                            </DescrPlaceholder>

                            <BottonInnerControlsPlaceholder>
                                <span
                                    style={{ cursor: "pointer", marginRight: 15 }}
                                    onClick={() => {
                                        setSelectedDistrict(undefined);
                                    }}
                                >
                                    {t("boew10f625d")}
                                </span>
                                <Button
                                    onClick={() => {
                                        setSelectedDistrict(undefined);
                                        setOverlayVisible(true);
                                    }}
                                >
                                    {t("4x68nucdtks")}
                                </Button>
                            </BottonInnerControlsPlaceholder>
                        </DistrictModalBox>
                    </DistrictModalOverlayInner>
                </DistrictModalOverlay>
            )}
        </Wrapper>
    );
}

const XLabel = styled.span`
    font-weight: bold;
    opacity: 0.5;
`;

const DescrPlaceholder = styled.div`
    max-height: calc(32vh - 100px);
    overflow-y: auto;
`;

const BottonInnerControlsPlaceholder = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
    margin-top: 5px;
    margin-bottom: 5px;
`;

const DistrictModalOverlay = styled.div`
    background: rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 1000;
`;

const DistrictModalOverlayInner = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const DistrictModalBox = styled.div`
    padding: 20px;
    box-sizing: border-box;
    width: 620px;
    border-radius: 6px;
    background: white;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

    max-height: calc(82vh - 100px);
    overflow-y: auto;

    @media (max-width: 720px) {
        width: 100%;
        padding: 10px;
    }
`;

const EventItem = styled.div`
    padding: 5px;
    border: 1px solid whitesmoke;
    border-radius: 6px;
    opacity: 0.9;
    margin-bottom: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    :hover {
        opacity: 1;
    }
`;

const SidebarInner = styled.div`
    background: white;
`;

const CloseFixed = styled.div`
    position: absolute;
    z-index: 4;
    top: 30px;
    left: 30px;
    padding: 10px;
    border-radius: 10px;
    background: white;
    cursor: pointer;
    color: black;
    font-size: 24px;
    font-weight: bold;
    border: 1px solid lightgrey;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`;

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    opacity: 0.9;
    cursor: pointer;

    :hover {
        opacity: 1;
    }
`;

const OverplayPlaceholder = styled.div`
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 3;
`;

const InnerOverlay = styled.div`
    position: relative;
    background: white;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

function useOnClickOutside(ref, handler) {
    useEffect(
        () => {
            const listener = (event) => {
                // Do nothing if clicking ref's element or descendent elements
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
            return () => {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            };
        },
        // Add ref and handler to effect dependencies
        // It's worth noting that because passed in handler is a new ...
        // ... function on every render that will cause this effect ...
        // ... callback/cleanup to run every render. It's not a big deal ...
        // ... but to optimize you can wrap handler in useCallback before ...
        // ... passing it into this hook.
        [ref, handler],
    );
}
